<div class="cv-collapsible-content cv-collapsible-component">
    <ng-content></ng-content>
</div>
